export const tableColumns = [
  {
      Header: 'Toolpusher',
      accessor: 'created_by',
  },
  {
      Header: 'Rig',
      accessor: 'rig_name',
      width: 50,
  },
  {
      Header: 'Date',
      accessor: 'daily_date',
      Cell: (cell) => {
          const row = cell.row.original;
          let dailyId = typeof row !== 'undefined' ? row.daily_id : null;
          return (
              <a
                href={`/data_entry/daily/daily/edit/${dailyId}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                  <b>{cell.value}</b>
              </a>
            );
      }
  },
  {
      Header: 'Shift',
      accessor: 'daily_shift',
  },
  {
      Header: 'Client',
      accessor: 'client_name',
      width: 300,
  },
  {
      Header: 'Job',
      accessor: 'job_number',
  },
  {
      Header: 'Hours',
      accessor: 'hours',
  },
  {
      Header: 'Description',
      accessor: 'description',
      width: 200,
  },
];
